import HandymanIcon from '@mui/icons-material/Handyman';

const icons = {
  HandymanIcon
};

const repairApproval = {
  id: 'registeredcases',
  type: 'group',
  children: [
    {
      id: 'repairApproval',
      title: 'Repair Approval',
      type: 'item',
      url: '/repairApproval',
      icon: icons.HandymanIcon,
    }
  ]
};

export default repairApproval;
